import { reconcileScaffoldItems } from "../reconcileScaffoldItems";
import { IScaffoldActionColsChanged, ScaffoldState } from "./interface";

/**
 * Handles the COLS_CHANGED action by reconciling the new columns against the previous snapshot,
 * updating enteringColIds, leavingCols, and prevCols on the scaffold state.
 *
 * @param action - The COLS_CHANGED action carrying the updated columns array.
 * @param state - The current scaffold state.
 * @returns Updated scaffold state reflecting the column changes, or the unchanged state if no ids changed.
 */
export const scr_colsChanged = <T>(
  action: IScaffoldActionColsChanged<T>,
  state: ScaffoldState<T>,
): ScaffoldState<T> => {
  const reconciliation = reconcileScaffoldItems(action.cols, state.prevCols, state.leavingCols);
  return !reconciliation.hasChanged
    ? state
    : {
        ...state,
        enteringColIds: reconciliation.enteringIds,
        leavingCols: reconciliation.nextLeavingItems,
        prevCols: action.cols,
      };
};
